// ─────────────────────────────────────────────────────────
// Feature-Schalter (Frontend)
// ─────────────────────────────────────────────────────────
// Gegenstück zu backend/src/config/features.ts. Beide Seiten müssen dieselbe
// Antwort geben — sonst zeigt die App einen Knopf, den der Server ablehnt.

import { toInternationalPhone } from '../utils/phone.js';

/**
 * WhatsApp (Evolution API) — PAUSIERT seit 2026-08-01.
 *
 * Solange false:
 * - kein WhatsApp-Tab in der Handy-Navigation, kein Eintrag im Dashboard-Menü
 * - kein WhatsApp-Schritt im Einrichtungs-Assistenten
 * - kein WhatsApp-Bereich in den Einstellungen (Verbindungen, Anhänge, Mahnung)
 * - Senden per WhatsApp öffnet die WhatsApp-App mit fertiger Nachricht +
 *   Link auf das Dokument, statt die Datei über den Server zu schicken
 *
 * Nichts davon ist gelöscht. Zum Zurückholen: hier und im Backend auf true.
 * Details: docs/whatsapp-pausiert.md
 */
export const WHATSAPP_ENABLED = false;

/**
 * Klick-zu-Chat-Adresse von WhatsApp: öffnet die WhatsApp-App (auf dem Rechner
 * WhatsApp Web) beim Chat DIESER Nummer, optional mit fertig getipptem Text.
 * Gesendet wird immer vom Menschen — das ist der ganze Unterschied zum
 * Server-Versand, und der Grund, warum hier keine Datei mitgehen kann.
 * Nummer ohne +, Leerzeichen und Striche; der Text muss kodiert werden.
 *
 * Die Nummer läuft PFLICHT durch toInternationalPhone: in der Schweiz steht in
 * den Kundendaten «079 123 45 67», und ohne Landesvorwahl öffnet WhatsApp den
 * Chat nicht — der Knopf tat dann einfach nichts (gemeldet 2026-08-06).
 */
export function waChatUrl(phone, text) {
  const digits = toInternationalPhone(phone);
  const q = text ? `&text=${encodeURIComponent(text)}` : '';
  return `https://api.whatsapp.com/send/?phone=${digits}${q}&type=phone_number&app_absent=0`;
}
